import React, { Component } from 'react';
import './Banner.css';
import { Image, Picture } from 'pixboost-react';
import pixboostConfig from '../../../config/pixboost';
import EditBar from '../EditBar/EditBar';
import Cta from '../Cta/Cta';

class Banner extends Component {
  toggleEditing(toggle) {
    if (this.props.onToggleEditing) {
      this.props.onToggleEditing(toggle);
    }
  }

  render() {
    const {
      title,
      image,
      imageBasePath,
      link,
      isResponsiveImage,
      images,
      sectionIndex,
      contentBlockIndex,
      removeContentBlock,
      ctaPosition,
      ctaMobilePosition,
      buttonText,
      backgroundColour,
      description,
      titleFontSize,
      linkTag
    } = this.props;

    return (
      <div
        className={`banner ${backgroundColour ? backgroundColour : ''} ${
          description ? 'has-description' : ''
        } ${link ? 'has-link' : ''} edit-wrapper`}
      >
        <Cta
          title={title}
          buttonText={buttonText}
          ctaPosition={ctaPosition}
          ctaMobilePosition={ctaMobilePosition}
          link={link}
          linkTag={linkTag}
          description={description}
          titleFontSize={titleFontSize}
        />
        {isResponsiveImage && Object.keys(images).length > 0 && (
          <Picture
            alt={title}
            breakpoints={{
              lg: {
                src: imageBasePath + images.lg
              },
              md: {
                src: imageBasePath + images.md
              },
              sm: {
                src: imageBasePath + images.sm
              }
            }}
            config={pixboostConfig}
            lazy={false}
          />
        )}
        {!isResponsiveImage && image && (
          <a
            title={title}
            href={`${link ? link : ''}${linkTag ? linkTag : ''}`}
          >
            <Image
              src={imageBasePath + image}
              alt={title}
              config={pixboostConfig}
              lazy={false}
            />
          </a>
        )}
        <EditBar
          toggleEditing={() => this.toggleEditing(true)}
          removeContentBlock={() =>
            removeContentBlock(sectionIndex, contentBlockIndex)
          }
        />
      </div>
    );
  }
}

export default Banner;



// WEBPACK FOOTER //
// ./src/components/landingPage/Banner/Banner.js